<template>
  <div class="slider">
    <div class="slider__content">
      <!-- <img class="d__none" src="@/assets/images/png/newmainbanner.png" alt="asd" />
            <img class="m__none" src="../../assets/images/png/newmainbannermobile.png" alt="asd" /> -->
      <div class="slider__items container">
        <div class="slider__items-row">
          <div class="slider__items-row-col1">
            <div class="slider__content-text">
              <span class="font-48"
                >Стройное тело в энергии и в легкости</span>
                <img class="m__none" src="@/assets/images/png/mainGirl.png" alt="">
              <p class="font-20">
                Уже более 40.000 девушек прошли авторскую программу по гармоничному развитию своего тела и сознания
              </p>
              <!-- <p class="font-20">Удобная онлайн платформа для тренировок</p>
              <p class="font-20">Фигура мечты без жестких диет и запретов</p> -->
            </div>
            <div class="slider__content-buttom">
              <span class="font-20">Попробуй первую тренировку за 0 ₸</span>
              <button
                class="font-16 btn_blue"
                @click="scrollToSection(links[0].id)"
              >
                {{ links[0].name }}
              </button>
            </div>
          </div>
          <div class="slider__items-row-col2 d__none">
            <img src="@/assets/images/png/mainGirl.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [{ name: "Присоединиться", id: "tariffes" }],
    };
  },
  methods: {
    scrollToSection(link) {
      this.$emit("scroll", link);
    },
  },
};
</script>

<style></style>
